module.exports = __webpack_public_path__ + "media/images/front/pc/features/search/doctors/map-f4038c202ec42e0139bd547f9f426b88.svg";